import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const LiechtensteinFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15411'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15411)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 7.46667H20V0H0V7.46667Z'
					fill='#0A3B97'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V7.46667H0V14Z'
					fill='#E6273E'
				/>
			</g>
		</svg>
	);
};

export default LiechtensteinFlagIcon;
